import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLocale } from "@/locale/LocaleContext";
import { titleForPath } from "@/lib/pageTitle";

export function DocumentTitle() {
  const { pathname } = useLocation();
  const { m } = useLocale();

  useEffect(() => {
    document.title = titleForPath(pathname, m);
  }, [pathname, m]);

  return null;
}
